import {connect} from 'react-redux'
import NavBar from '../components/NavBar/NavBar'

function mapStateToProps(state, props) {
  return {
    browser: state.browser
  }
}

export default connect(mapStateToProps)(NavBar)


// WEBPACK FOOTER //
// ./src/containers/NavBar.js